(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalAgendaLabelDropdown', [AgendaLabelDropdownDirectiveFn]);

    /* directive for the agenda label list */
    function AgendaLabelDropdownDirectiveFn() {

        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                labels: '=',
                model: '=',
                appendToBody: '=?',
                deletable: '@?'
            },
            replace: true,
            templateUrl: '/app/global/templates/rf-global-agenda-label-dropdown.template.html'
        };
        return directive;


        function link(scope, element, attrs) {

            activate();

            // activate
            function activate() {
                if (typeof scope.deletable === 'undefined') {
                    scope.deletable = false;
                }//if
            }

            // select 
            scope.select = function (label) {
                scope.model = label;
            };

            // delete
            scope.delete = function () {
                scope.model = null;
            };

        } // link

    }

})();